/**
 * Icon from SVG sprite (public/icons/sprite.svg).
 * name = filename without .svg (e.g. "icon-cart", "logo", "Telegram").
 */
const PUBLIC_URL = process.env.PUBLIC_URL || '';

const Icon = ({
	name,
	className,
	width,
	height,
	style,
	ariaHidden = true,
	ariaLabel,
	...rest
}) => {
	const href = `${PUBLIC_URL}/icons/sprite.svg#${name}`;
	return (
		<svg
			className={className}
			width={width}
			height={height}
			style={style}
			aria-hidden={ariaHidden}
			aria-label={ariaLabel}
			{...rest}
		>
			<use href={href} />
		</svg>
	);
};

export default Icon;
